/**
 * @file stock-view.ts
 * @description Режим экрана остатков: текущий пул или журнал движений
 * (phase19.23 этап A, по образцу `picking-view.ts`).
 *
 * Режим живёт в URL (`?view=movements`), а не в состоянии страницы: ссылку на
 * журнал движений отправляют коллеге, а «Назад» из карточки обязано вернуть
 * туда, откуда ушли.
 */

/** Режимы экрана остатков. */
export type StockView = "stock" | "movements";

/** Значение `?view=` в URL; всё неизвестное — остатки. */
export function parseStockView(raw: string | null): StockView {
  return raw === "movements" ? "movements" : "stock";
}

/** Подписи переключателя — один источник для вкладок и заголовков. */
export const STOCK_VIEW_LABEL: Record<StockView, string> = {
  stock: "Остатки",
  movements: "Движения",
};
